import React from 'react';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () => import(/* webpackChunkName: 'VideoLoader' */ './Video'),
  loading: () => null,
});

export default class VideoLoader extends React.Component {
  render() {
    return <LoadableComponent {...this.props} />;
  }
}
